const PROJECT_REVIEW_STATUSES = [
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Reviewed' },
  { id: 2, name: 'Approved' }
];

export function formatProjectReviewStatus(status, statusCode = null) {
  if (status) {
    return status;
  }

  const option = PROJECT_REVIEW_STATUSES.find(({ id }) => id === Number(statusCode));
  return option ? option.name : '-';
}

export function projectReviewStatusOptions() {
  return PROJECT_REVIEW_STATUSES.map(status => ({ ...status }));
}

export function normalizeProjectAIStatus(status, statusCode = null) {
  if (!status && !statusCode) {
    return null;
  }

  const normalizedStatus = String(status || '').trim().toLowerCase();
  if (['processing', 'running', 'starting'].includes(normalizedStatus)) {
    return 'Process';
  }
  if (['error', 'failed', 'failure'].includes(normalizedStatus) || Number(statusCode) >= 400) {
    return 'Error';
  }
  return 'Ready';
}

export function latestProjectAIStatus(jobs = []) {
  const validJobs = Array.isArray(jobs) ? jobs.filter(Boolean) : [];
  if (validJobs.length === 0) {
    return null;
  }

  const latestJob = validJobs.slice().sort((a, b) => (a.created || 0) - (b.created || 0)).pop();
  return normalizeProjectAIStatus(latestJob.status, latestJob.statusCode);
}

export function getProjectQcStatus(project = {}) {
  const status = formatProjectReviewStatus(project.qcStatus, project.qcStatusCode);
  return status !== '-' ? status : null;
}

export function formatProjectQcStatus(project = {}) {
  return getProjectQcStatus(project) || '-';
}

export function getProjectCaseId(project = {}) {
  return project.caseId || project.name || '-';
}
